import { FormattedMessage, useIntl } from 'react-intl';
import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import InstallPromptLocation from '@alltrails/amplitude/enums/InstallPromptLocation';
import Button from '@alltrails/denali/components/Button';
import { useExperiments } from '@alltrails/experiments';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import useDeeplink from '../../hooks/useDeeplink';
import { deepLinkRedirect } from '../../utils';
import AppPromotion from '../AppPromotion';
import BaseInstallInterstitial from '../BaseInstallInterstitial';
import styles from './InstallMiniVariantInterstitial.module.scss';

type InstallMiniVariantInterstitialProps = {
  isOpen?: boolean;
  onRequestClose?: () => void;
  promptLocation: InstallPromptLocation;
  displayTrigger?: CarouselDisplayTrigger;
  deeplinkData?: DeeplinkData;
};

const InstallMiniVariantInterstitial = ({
  isOpen = false,
  onRequestClose,
  promptLocation,
  displayTrigger,
  deeplinkData
}: InstallMiniVariantInterstitialProps) => {
  const intl = useIntl();
  const experiments = useExperiments();
  const isAppsFlyerEnabled = experiments['web-appsflyer-migration']?.value === 'on';
  const getDeeplink = useDeeplink({ deeplinkData, isOpen, promptType: 'interstitial', displayTrigger });

  const handleContinueInApp = () => {
    deepLinkRedirect(getDeeplink(), 'interstitial', promptLocation, isAppsFlyerEnabled ? 'native_with_appsflyer_link' : 'native', displayTrigger);
  };

  return (
    <BaseInstallInterstitial
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      promptLocation={promptLocation}
      displayTrigger={displayTrigger}
    >
      <div className={styles.content}>
        <AppPromotion heading={<FormattedMessage defaultMessage="AllTrails is better in the app" />} />

        <Button
          width="fullOnMobile"
          variant="primary"
          text={intl.formatMessage({ defaultMessage: 'Continue in app' })}
          onClick={handleContinueInApp}
          testId="continue-in-app-button"
        />
      </div>
    </BaseInstallInterstitial>
  );
};

export default InstallMiniVariantInterstitial;
